import { Factory } from 'miragejs'

export default Factory.extend({
  subscriptionType: 'reading',
  districtAdminsSynchronised: true,
  schoolAdminsSynchronised: true,
  schoolsSynchronised: true,
  sectionsSynchronised: true,
  studentsSynchronised: true,
  teachersSynchronised: true,
})
